// extracted by mini-css-extract-plugin
export var wagonTagsGroup = "b8480d63c4a8858657cfe41842827f6f-css";
export var headingAndButton = "_38d23126e3c163116ce2816d6b8c051c-css";